// extracted by mini-css-extract-plugin
module.exports = {"travelInfo_M":"travelInfo_M--2HVps","item":"item--1QDY-","title":"title--kOvtE"};